/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityPermissionsTypeFromJSON, EntityPermissionsTypeToJSON, } from './';
export function SearchEntityPermissionsRequestFromJSON(json) {
    return SearchEntityPermissionsRequestFromJSONTyped(json, false);
}
export function SearchEntityPermissionsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        type: EntityPermissionsTypeFromJSON(json['type']),
        targetId: json['targetId'],
    };
}
export function SearchEntityPermissionsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        type: EntityPermissionsTypeToJSON(value.type),
        targetId: value.targetId,
    };
}
